import React, {FC, ReactNode} from 'react';
import styled, {css} from 'styled-components';

import {Handler} from '../../../../../../shared/helpers/src/react/reactHelpers';
import {fontWeights} from '../../../../../../shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

export interface PageTabProps {
  title: ReactNode;
  isSelected: boolean;
  onClick: Handler;
}

/*
 * Styles.
 */

interface StyledPageTabDivProps {
  $isSelected: boolean;
}

const StyledPageTabDiv = styled.div<StyledPageTabDivProps>`
  // negative margin is so we can hide border when tab is selected
  margin-bottom: -1px;
  color: ${(p) => p.theme.greys.shade70};
  font-weight: ${fontWeights.semibold};
  font-size: 14px;
  line-height: 16px;
  padding: 6px 12px 7px;
  border-top: 1px solid ${(p) => p.theme.greys.shade30};
  border-left: 1px solid ${(p) => p.theme.greys.shade30};
  border-right: 1px solid ${(p) => p.theme.greys.shade30};
  border-radius: 8px 8px 0 0;

  ${(p) =>
    p.$isSelected &&
    css`
      border-bottom: 1px solid ${p.theme.greys.white};
      color: ${p.theme.greys.shade90};
    `};

  ${(p) =>
    !p.$isSelected &&
    css`
      &:hover {
        // Using text-shadow to avoid changing the tab width on hover with a bolder font
        text-shadow: 0px 0px 1px ${p.theme.greys.shade60};
        color: ${p.theme.greys.shade90};
        background-color: ${p.theme.greys.shade20};
      }
    `}
`;

/*
 * Component.
 */

export const PageTab: FC<PageTabProps> = (props) => {
  const {title, isSelected, onClick} = props;
  return (
    <StyledPageTabDiv $isSelected={isSelected} onClick={onClick}>
      {title}
    </StyledPageTabDiv>
  );
};
